// extracted by mini-css-extract-plugin
export default {"text":"privacyPolicy_text__hj00c","heading":"privacyPolicy_heading__TIAac","section":"privacyPolicy_section__5QfOh"};